import styled from 'styled-components';

export const StyledFooter = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
`;
export const StyledTableWrapper = styled.div`
  .desktop {
    width: 100%;
    height: 100%;
    padding: 0 calc((100vw - 1280px) / 2) 16px;
    @media screen and (max-width: ${(props) => props.theme.sizes.desktop}) {
      padding: 0 16px 12px 16px;
    }
    @media screen and (max-width: ${(props) => props.theme.sizes.tablet}) {
      padding: 0 4px 8px 4px;
    }
    position: absolute;
    overflow: auto;
    z-index: 2;
  }
  .mobile {
    width: 100%;
    height: 100%;
  }
`;
export const StyledHeader = styled.div`
  .StudyLobby_header {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: flex-start;
    padding-top: 8px;
    &_mobile {
      padding: 10px 0;
      flex-flow: row nowrap;
      justify-content: space-between;
      background: #101315;
      color: white;
      align-items: center;
      border-bottom: 1px solid #91b9cd;
      .version {
        color: #FFFFFF0A;
        font-size: 0.75em;
        transition: color 0.2s ease;
      }
      &:hover .version {
        color: #91C9DD97;
      }
      div {
        display: flex;
        flex-direction: column;
        label {
          font-size: 8px;
        }
        select {
          background: #2b3746;
          border-color: #2b3746;
          padding: 2.5px;
          color: white;
          border-radius: 5px;
          &:focus {
            outline: none;
          }
        }
        p {
          margin: 0;
          font-size: 12px;
        }
      }
      > * {
        padding: 0;
        margin: 0 20px;
      }
      img {
        width: 30px;
        padding: 0;
      }
    }
  }
`;
export const StyledLobbyLanguage = styled.div`
  label {
    color: #91b9cd;
    font-size: 1rem;
    font-weight: 100;
    padding-right: 8px;
  }
  svg {
    color: #6f89a6;
    padding-right: 8px;
  }
  select {
    margin-right: 6px;
    padding: 1px 2px;
    font-size: 1.0625rem;
    background-color: #273541;
    color: #a2cade;
    text-align: center;
    border: 1px solid #91b9cd;
    border-radius: 4px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
  }
`;
export const StyledTable = styled.div`
  .StudiesTable {
    margin-top: 32px;
      &_Filters {
        -webkit-datetime-edit-year-field: not([aria-valuenow]);
        -webkit-datetime-edit-month-field: not([aria-valuenow]);
        -webkit-datetime-edit-day-field: not([aria-valuenow]);
        background: ${(props) => props.theme.colors.grayBluer};
        color: ${(props) => props.theme.colors.white};
        padding: 10px 20px;
        border-radius: 10px 10px 0 0;
        .SearchButtonBox {
          text-align: right;
          .SearchButton {
            padding: 4px 16px;
            margin-right: 8px;
            color: #91b9cd;
            border: 1px solid #91b9cd;
            background: #101315;
            font-size: ${(props) => props.theme.font.size.semilarge};
            font-weight: ${(props) => props.theme.font.weight.ultralight};
            cursor: pointer;
            border-radius: 4px;
            &:hover {
              background: #1d2225;
            }
            &:active {
              background: #91b9cd;
              color: #101315;
            }
        }
        }
        &_Row_Search {
          align-items: center;
          gap: 8px;
          padding: 4px 0;

          .StudyRowClickMode {
            display: flex;
            flex: 1 1 auto;
            align-items: center;
            gap: 6px;

            label {
              display: flex;
              align-items: center;
              min-height: 38px;
              line-height: 1.2;
              transform: translateY(3px);
              font-size: ${(props) => props.theme.font.size.medium};
              color: #c4c9cd;
              cursor: pointer;
            }

            .StudyRowClickModeSwitch {
              .MuiSwitch-colorPrimary.Mui-checked {
                color: #2196f3;
              }

              .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
                background-color: #2196f3;
              }
            }
          }

          .SearchButtonBox {
            margin-left: auto;
          }
        }
        &_Row {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding: 10px 0;
          &:first-child {
            justify-content: space-between;
          }
          &_SubRow {
            width: 100%;
            display: flex;
          }
          &_Cell {
            padding-right: 10px;
            width: calc(100%/ ${(props) => props.filtersPerRow});
            text-align: left;
            border-top: 0;
            &:nth-child(${(props) => props.filtersPerRow}) {
              padding-right: 0px;
            }
            label {
              display: flex;
              overflow: hidden;
              white-space: nowrap;
              align-items: center;
              cursor: pointer;
              width: calc(100% - 10px);
              min-width: 95px;
              margin: 0 auto;
              font-weight: 400;
              padding: 5px 0px;
              user-select: none;
              font-size: ${(props) => props.theme.font.size.medium};
              font-weight: ${(props) => props.theme.font.weight.bold};
              :hover {
                color: ${(props) => props.theme.colors.smokeWhite};
              }
            }
            input, select {
              height: 32px;
              padding: 0 12px;
              color: ${(props) => props.theme.colors.white};
              cursor: pointer;
              border: 0;
              background: ${(props) => props.theme.colors.gray800};
              font-size: ${(props) => props.theme.font.size.medium};
              font-weight: ${(props) => props.theme.font.weight.ultralight};
              border-radius: 4px;
              width: 100%;
              :focus {
                outline: 0;
              }
            }
            
            .DateRangePicker {
              div {
                .DateRangePickerInput {
                  background: ${(props) => props.theme.colors.gray800};
                  border: 0;
                }
              }
            }
            .DateInput_input {
              text-align: center;
              border: 0;
              padding: 0 10px;
              ::placeholder {
                color: #91b9cd;
              }
            }
            .DateRangePickerInput_clearDates {
              padding: 2px;
              right: 7px;
            }
            .DateInput_1 {
              width: 125px;
              background: ${(props) => props.theme.colors.gray800};
              border-radius: 4px;
            }
          }
          &_Presets {
            .PresetDateRangePicker_button {
              padding: 4px 8px;
              white-space: nowrap;
              color: #91b9cd;
              border: none;
              background: #101315;
              font-size: ${(props) => props.theme.font.size.small};
              font-weight: ${(props) => props.theme.font.weight.ultralight};
              cursor: pointer;
              border-radius: 4px;
              width: calc(100% - 10px) !important;
              &:focus {
                outline: 0;
                background: #91b9cd;
                border: none;
                color: #101315;
              }
            }
          }
        }
        .total_studies {
          display: flex;
          justify-content: space-between;
          padding: 2px 0;
          margin-bottom: -12px;
          color: #91C9DD;
          background: ${(props) => props.theme.colors.grayBlue};
          span {
            font-size: .875em;
          }
          p {
            font-size: 0.75em;
            color: #FFFFFF0A;
            margin-bottom: 0;
            cursor: default;
            transition: color 0.2s ease;

            &:hover {
              color: #91C9DD97;
              transition: color 0.2s ease;
            }
          }
        }
      }
      &_BoxTable {
        padding: 7px;
        background: ${(props) => props.theme.colors.grayBluer};    
        border-radius: 0 0 13px 13px;
        &_Header {
          overflow-x: auto;
          position: sticky;
          top: 0;
          border-bottom: 1px solid #91b9cd;
          background-color: ${(props) => props.theme.colors.black};
          padding-top: 4px;
          padding-bottom: 4px;
          border-radius: 7px 7px 0px 0px;
          font-size: ${(props) => props.theme.font.size.medium};
          &_Content {
            font-weight: bold;
            color: #FFF;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
          }
          &::-webkit-scrollbar:horizontal {
            /* overflow: visible; */
            height: 9px;
            border-radius: 2px;
          }
        }
        &_Table {
          color: ${(props) => props.theme.colors.greyWhite};
          overflow-x: auto;  
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;
          border-radius: 5px;
          font-size: ${(props) => props.theme.font.size.small};
          div {
            .StudyLobby_StudiesTable_Table_Row {
              border-radius: 0;
            }
          }
          &_Study {
            display: flex;
            flex-direction: column;
            background-color: ${(props) => props.theme.colors.grayBluer2};
            overflow-anchor: none;
            transition: background-color 0.15s ease;
            &:hover {
              background-color: #18242f;
            }
            &.is_selected {
              background-color: #18242f;
            }
            &:nth-of-type(odd) {
              background-color: ${(props) => props.theme.colors.black};
              &:hover {
                background-color: #12171f;
              }
              &.is_selected {
                background-color: #18242f;
              }
            }
          }
          &_Row_Header {
            display: flex;
            flex-direction: row;
            padding: 15px 10px;
            justify-content: space-around;
            color: #91b9cd;
            cursor: default;
          }
          &_Row {
            display: flex;
            flex-direction: row;
            padding: 15px 10px;
            // border-bottom: 1px solid #334040;
            justify-content: space-around;
            cursor: pointer;
            background-color: transparent;
            transition: background-color 0.15s ease;
            &:hover {
              background-color: transparent;
              transition: background-color 0.3s ease;
            }
            :first-child {
              .StudyLobby_StudiesTable_Table_Row_Cell {
                font-size: ${(props) => props.theme.font.size.medium};
                word-wrap: normal;
              }
            }
            &_Cell {
              padding-right: 20px;
              line-height: 15px;
              max-height: 30px;
              overflow: hidden;
              line-break: normal;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              &:last-child { 
                padding-right: 0px;
              }
              &.small_width {
                width: 100px;
              }
              &.medium_width {
                width: 160px;
              } 
              &.large_width {
                width: 240px;
              }
              &.series_column {
                width: 70px;
              }
              &.images_column {
                width: 70px;
              }
            }
          }
          &_StudyActions {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            max-height: 0;
            padding: 0 10px;
            overflow: hidden;
            opacity: 0;
            pointer-events: none;
            cursor: pointer;
            transition: max-height 0.5s ease-in-out, opacity 0.35s ease-in-out, padding 0.5s ease-in-out;
            &.is_expanded {
              max-height: 300px;
              padding-bottom: 10px;
              opacity: 1;
              pointer-events: auto;
            }
          }
          &_StudySeries {
            flex: 1;
            max-height: 240px;
            overflow-y: auto;
            margin-right: 16px;
          }
          &_StudySeriesMessage {
            padding: 5px 0;
          }
          &_StudySeriesItem {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            padding: 2px 0;
            margin-bottom: 1px;
            cursor: pointer;
            input {
              flex: 0 0 auto;
              margin: 2px 0 0;
              accent-color: #91b9cd;
              cursor: pointer;
            }
            span {
              overflow-wrap: anywhere;
            }
            .series_modality {
              color: #8299a4;
            }
            .series_instance_count {
              font-size: 0.85em;
              color: #8299a4;
            }
          }
          .StudiesTable_OpenStudyButton {
            flex-shrink: 0;
            padding: 5px 12px;
            color: #91b9cd;
            border: 1px solid #91b9cd;
            background: #101315;
            font-size: ${(props) => props.theme.font.size.small};
            cursor: pointer;
            border-radius: 4px;
            &:hover, &:focus {
              color: #101315;
              background: #91b9cd;
              outline: none;
            }
          }
          &_StudyActionButtons {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;
            flex-shrink: 0;
          }
        }
      }
    
    &_mobile {
      margin-top: 0px;
      .StudiesTable {
        &_Filters {
          padding: 0px 10px 10px 10px;
          border-bottom: 1px solid #91b9cd;   
          border-radius: 0px; 
          &_Row {
            &:last-child {
              padding: 4px 0px 2px 0px;
            }
            &_Cell {
              padding-top: 5px;
              label {
                padding: 0px;
              }
              input {
                background: ${(props) => props.theme.colors.gray800};
              }
            }
          }
        }
        &_BoxTable {
          padding: 0px;
          border-radius: 0px;
          &_Table {
            &_Row {
              padding: 11px 10px;
              :first-child {
              }
              :nth-of-type(odd) {
              }
              :last-child {
              }
              &_Cell {
                padding-right: 10px;
                &:last-child {
                  padding-right: 0px;
                }

                &.small_width {
                  width: 70px;
                }
                &.medium_width {
                  width: 120px;
                } 
                &.large_width {
                  width: 160px;
                }
              }
            }
          }
        }
      }
      .total_studies {
        padding: 0;
        border-bottom: 2px solid black;
        span {
          padding: 0;
          font-size: 22px;
          color: #91b9cd;
        }
        p {
        }
      }
    }
  }
`;
export const StyledHeaderMenuGroup = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
`;
